import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deptenquirydetails-grid',
  templateUrl: './deptenquirydetails-grid.component.html',
  styleUrls: ['./deptenquirydetails-grid.component.css']
})
export class DeptenquirydetailsGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-grid/deptenquirydetails-grid.component.ts